<template>
  <div class="notifiction-bell-point">
    <span :class="{
      'notifiction-bell-point__text-align': true,
      'notifiction-bell-point__text-align__color': newNotificationCount > 0
      }"
      @click="showNotificationsClickEvent">
      {{newNotificationCount}}
    </span>
    <span class="notifiction-bell-point__bell-dot" @click="showNotificationsClickEvent">
      <icon name="bell" class="notifiction-bell-point__bell-outline" scale="1.3"></icon>
    </span>
  </div>
</template>

<script>
import {PopoverFactory} from '@/components/common/popover'
import 'vue-awesome/icons/bell'
import Icon from 'vue-awesome/components/Icon'
/**
 * When clicked, display the Notifications that are injected into this component
 * Display the notification number given to this component that are of status NEW
 */
export default {
  components: {
    Icon
  },
  props: {
    notifications: {
      type: Array,
      default: () => []
    },
    deleteNotificationFunc: Function,
    actionEngine: Object
  },
  computed: {
    newNotificationCount () {
      if (this.notifications.length > 0) {
        // TODO get the constant value for the NEW
        return this.notifications.filter(n => n.status === 'new').length
      } else {
        return 0
      }
    }
  },
  methods: {
    showNotificationsClickEvent (e) {
      let target = e.currentTarget
      this.showNotifications(target)
    },
    showNotifications (target) {
      // TODO this function is still at a race condition....
      if (this.notifications.length > 0) {
        let popover = null
        popover = PopoverFactory.createNotification({
          direction: 'left',
          notifications: this.notifications,
          actionEngine: this.actionEngine,
          deleteNotificationFunc: (n) => {
            this.deleteNotificationFunc(n)
            popover.dismiss()
            setTimeout(() => this.showNotifications(target), 20)
          },
          parent: target,
          colorTheme: 'white'
        })
      }
    }
  }
}
</script>

<style lang="scss">
.notifiction-bell-point {
  &__bell-dot {
    display: inline-block;
    text-align: center;
    cursor: pointer;
  }

  &__bell-outline {
    position: relative;
    transform: rotate(30deg);
    top: 5px;
    left: 1px;
  }

  &__text-align {
    position: relative;
    top: 3px;
    font-size: 18px;

    &__color {
      text-align: center;
      display: inline-block;
      background-color: red;
      height: 30px;
      width: 30px;
      border-radius: 50%;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// NotificationsBellPoint.vue?2d8e7c52